import styled from "styled-components";
import { StyledCardBaseProps } from "./CardBase.types";
import Box from "../../boxes/Box";

export const StyledCardBase = styled(
	({ backgroundColor, borderRadius, ...props }: StyledCardBaseProps) => (
		<Box {...props} />
	)
)<StyledCardBaseProps>`
	position: relative;
	overflow: hidden;
	box-sizing: border-box;

	${({ theme, backgroundColor, borderRadius = "xl" }) => ({
		backgroundColor: theme.palette.hexFor(backgroundColor),
		borderRadius: theme.radii[borderRadius],
	})}
`;
